import { lazy } from 'react';

export default {
  exact: false,
  name: 'GIMACPay Merchant',
  protected: true,
  path: '/gimac-merchant-pay',
  component: lazy(() => import('containers/Gimac/MerchantPay')),
};
